module.exports = __webpack_public_path__ + "img/arrow-prev.c3ae4010.svg";